const Point = () => {
  return (
    <>
      <div className="comingSoon">Coming Soon</div>
      <h2>ポイント管理（全ショップ合計）</h2>

      <h4>サマリ</h4>
      <div className="listSummary">
        <ul>
          <li>
            <div className="title">当月成果</div>
            <div className="data">11,000<span>円</span></div>
          </li>
          <li>
            <div className="title">前月成果</div>
            <div className="data">8,000<span>円</span></div>
          </li>
          <li>
            <div className="title">前々月成果</div>
            <div className="data">1,000<span>円</span></div>
          </li>
        </ul>
      </div>

      <h4>ユーザー一覧（サイゼ品川店）</h4>

      <div className="tableDataList">
        <table>
          <tbody>
            <tr>
              <th>image</th>
              <th>id</th>
              <th>name</th>
              <th>service</th>
              <th>url</th>
              <th>detail</th>
            </tr>
            <tr>
              <td>
                <img src="./images/ad-1.png" alt="ad" />
              </td>
              <td>
                1
              </td>
              <td>
                株式会社WOWOW
              </td>
              <td>
                いつでもどこでも楽しめる番組配信サービス【WOWOWオンデマンド】
              </td>
              <td>
                https://www.smares.co.jp/?af=000001&amp;mid=000001
              </td>
              <td>
                1成約10,000円。　※成果は末締めの翌々月お支払い
              </td>
            </tr>
            <tr>
              <td>
                <img src="./images/ad-2.png" alt="ad" />
              </td>
              <td>
                2
              </td>
              <td>
                エヌ・ティ・ティ・ソルマーレ株式会社
              </td>
              <td>
                コミックシーモア　販売促進プログラム_MyLink対応
              </td>
              <td>
                https://www.smares.co.jp/?af=000002&amp;mid=000002
              </td>
              <td>
                1成約1,000円。　※成果は末締めの翌々月お支払い
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
export default Point;